const toggleFavourite = async (releaseId) => {
  const res = await fetch(`/api/favourite`, {
    headers: { 'content-type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ release: releaseId })
  })
  const response = await res.json()
  return response
}

module.exports = toggleFavourite
